
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2025-01-25-supabase-todo-app-team",
      function () {
        return require("private-next-pages/blogs/2025-01-25-supabase-todo-app-team/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2025-01-25-supabase-todo-app-team"])
      });
    }
  